module.exports = __webpack_public_path__ + "static/img/logo-yl.8f7faaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/logo-yl.png
// module id = 3wNV
// module chunks = 1